import BorderEditor from './BorderEditor';

export default BorderEditor;
